import { useEffect, useState } from "react";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import { Oval } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const Specification = () => {
  const [isError, setError] = useState(false);
  const [categoryDrp, setCategoryDrpData] = useState([]);
  const [specificationData, setSpecificationData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    category_id: null
  });

  const getCategory = () => {
    axios.post(API_URL.CATEGORY_LIST, {}).then((res) => {
      setCategoryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCategoryDrpData(cd);
    });
  };

  const getSpecifications = (category_id) => {
    setLoading(true);
    axios.post(API_URL.SPECS_LIST, { category_id: category_id }).then(
      (res) => {
        if (res.data.status === 1) {
          setSpecificationData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };
  const saveSepcs = () => {
    if (formValue.category_id && formValue.name) {
      setSaveLoading(true);
      const pUrl = (formValue.id) ? API_URL.SPECS_UPDATE : API_URL.SPECS_SAVE;
      axios
        .post(pUrl, formValue)
        .then((res) => {
          setSaveLoading(false);
          if (res.data.status === 1) {
            getSpecifications(formValue.category_id);
            if (formValue.id) {
              toast.success("Updated", {
                autoClose: 3000,
              });
            } else {
              toast.success("Saved", {
                autoClose: 3000,

              });
            }
            resetForm();
          }
        })
        .catch(() => {
          setSaveLoading(false);
          toast.error("An error occurred. Please try again.", {
            autoClose: 3000,
          });
        });
    } else {
      setError(true);
      setSaveLoading(false);
      toast.error("Please enter valid details", {
        autoClose: 3000,

      });
      return false;
    }
  };

  const resetForm = () => {
    setSelectedCategory(null);
    setFormValue({
      id: null,
      category_id: null,
      name: ""
    });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };


  const editItem = (row) => {
    setSelectedCategory({
      label: row.category.name,
      value: row.category.id,
    })
    setFormValue({
      id: row.id,
      name: row.name ? row.name : "",
      category_id: row.category_id
    });
  };

  const deleteItem = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.SPECS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = specificationData.filter((r) => r.id != row.id);
              setSpecificationData(newData);
            }
            toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  useEffect(() => {
    if (formValue.category_id) {
      getSpecifications(formValue.category_id);
    }
  }, [formValue.category_id]);

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">{formValue.id ? "Edit" : "Add"} Specification</div>
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-4 col-md-4 col-sm-12">
                    <div className="form-group">
                      <label>
                        Category<span className="required-star">*</span>
                      </label>
                      <Select
                        options={categoryDrp}
                        value={selectedCategory}
                        styles={
                          isRequiredField("unit")
                            ? customRequireStyles
                            : customStyles
                        }
                        onChange={(e) => {
                          setSelectedCategory(e);
                          setFormValue({
                            ...formValue,
                            category_id: e.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        } 
                        id="name"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <label>&nbsp;</label>
                    <div className="form-group text-left">
                      <button
                        type="submit"
                        onClick={saveSepcs}
                        disabled={loading}
                        className="btn btn-primary"
                      >
                        {saveLoading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save Specification"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 mt-4">
          <div className="card">
            <div className="card-header">Specifications</div>
            <div className="card-body p-0">
              {loading && (
                <Oval
                  height={60}
                  width={60}
                  color="#7539ff"
                  wrapperStyle={{ justifyContent: "center" }}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#7539ff"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              )}
              <div className="table-responsive">
                <table className="table">
                  <thead className="">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Category Name</th>
                      <th className="text-center" style={{ width: "200px" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {specificationData.map((row, key) => {
                      return (
                        <tr key={key}>
                          <td style={{ width: "30px" }}>{key + 1}</td>
                          <td>{row.name}</td>
                          <td>{row.category.name}</td>
                          <td
                            className="d-flex justify-content-center gap-2"
                            style={{ width: "200px" }}
                          >
                            <button
                              onClick={() => editItem(row)}
                              className="btn btn-sm btn-secondary mr-2"
                            >
                              <i className="fa fa-edit me-1"></i> Edit
                            </button>
                            <button
                              onClick={() => deleteItem(row)}
                              className="btn btn-sm btn-danger"
                            >
                              <i className="fa fa-trash me-1"></i> Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specification;
